
import React from "react"
import App from "./App"
import { ShoesRegister } from "./View/register-shoes"
import { TopsRegister } from "./View/register-tops"
import { BottomsRegister } from "./View/register-bottoms"
import{ Login } from "./View/login"
import { BrowserRouter,Routes,Route } from "react-router-dom"
// import { Register_shoes } from "./registers/Register_shoes"
// import { Register_tops } from "./registers/Register_tops"

export const RouterConfig = () => {
    return(
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" index element={<Login/>}></Route>
                    {/* <Route path="/regist" element={<Register/>}></Route> */}
                    <Route path="/register-tops" element={<TopsRegister/>}></Route>
                    <Route path="/register-bottoms" element={<BottomsRegister/>}></Route>
                    <Route path="/register-shoes" element={<ShoesRegister/>}></Route>
                    <Route path="/login" element={<App/>}></Route>
                </Routes>
            </BrowserRouter>
            {/* <Routes>
                    <Route index element={<App/>}/>
                    <Route path="/register_shoes" element={<Register_shoes/>}/>
                    <Route path="/register_tops" element={<Register_tops/>}/>
                </Routes> */}
        </>
    )
}

